import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Jenn, 2026-10-26: no automatic reloads. An auto-reload-on-return (added and removed the same day) fired
// when the iPad keyboard closed after tapping Add, jumping her back to Monday mid-edit. The ↻ Refresh
// button on every page (DashboardLayout) is how the app updates.
